<div class="tag">
    @if (clicked.observed) {
        <button class="tag__body" type="button" (click)="onClick()">
            {{ option().label }}
        </button>
    } @else {
        <span class="tag__body">
            <span class="tag__label">{{ option().label }}</span>
        </span>
    }
    @if (removed.observed) {
        <button
            class="tag__remove"
            type="button"
            (click)="onRemove($event)"
            [attr.aria-label]="'Remove ' + option().label"
        >
            <span class="icon-close"></span>
        </button>
    }
</div>
